import { Button, Grid } from '@mui/material';

import { combineStyles, typedStyles } from '@/utils/styleUtils';

import { TSxStyles } from '@/types/common';

import { SimpleError } from './SimpleError';
import type { TErrorProps } from './types';

type TActionAndErrorProps = TErrorProps & {
  action: string;
  onClick: () => void;
  'data-testid'?: string;
  sx?: TSxStyles;
  withIcon?: boolean;
};

const styles = typedStyles({
  root: {
    paddingY: 0.5,
  },

  action: {
    flexShrink: 0,
    marginRight: 'auto',
    whiteSpace: 'nowrap',
  },

  error: {
    marginLeft: 1,
  },
});

export const ActionAndError = ({
  action,
  onClick,
  'data-testid': testId,
  sx,
  withIcon = false,
  ...errorProps
}: TActionAndErrorProps) => (
  <Grid sx={combineStyles(styles.root, sx)}>
    <Button
      size="small"
      variant="text"
      onClick={onClick}
      sx={styles.action}
      data-testid={testId}
      disableRipple
    >
      {action}
    </Button>

    <SimpleError color="error" withIcon={withIcon} {...errorProps} />
  </Grid>
);
